import { generate } from 'packages/identifiers'
import { getItem, setItem } from 'common/using-local-storage-key'

export const deviceId = getItem('messages.deviceId') || `dev-${generate()}`

export const tabId = sessionStorage.getItem('messages.tabId') || `tab-${generate()}`
setItem('messages.deviceId', deviceId)
sessionStorage.setItem('messages.tabId', tabId)
